export default "__VITE_ASSET__CR1s6n3O__"